/**
 * Phase 3 - Arabic translations module
 */
import enBase from './en.js';
import { translationsAr } from '../../utils/translations/translations.ar.js';
import { plansTranslationsAr } from '../../utils/translations/plans/plansTranslations.ar.js';

const merged = { ...enBase, ...translationsAr, ...plansTranslationsAr };
export default merged;
